import { t } from 'ttag';

const STUDY_HAS_ARTIFACT_REPORT_HOVER_TEXT = t`This study has report marked as artifact`;

export { STUDY_HAS_ARTIFACT_REPORT_HOVER_TEXT };
